export const SettingsPageView = require('./SettingsPageView').default;
export const SettingsDetailPageView = require('./SettingsDetailPageView').default;
export const SettingsUpdatePageView = require('./SettingsUpdatePageView').default;
